const dashboardConstants = {
  GET_ALL_TERMINAL_SUMMARY_START: "GET_ALL_TERMINAL_SUMMARY_START",
  GET_ALL_TERMINAL_SUMMARY_SUCCESS: "GET_ALL_TERMINAL_SUMMARY_SUCCESS",
  GET_ALL_TERMINAL_SUMMARY_FAILED: "GET_ALL_TERMINAL_SUMMARY_FAILED",
  FILTER_TERMINAL_SUMMARY_START: "FILTER_TERMINAL_SUMMARY_START",
  FILTER_TERMINAL_SUMMARY_SUCCESS: "FILTER_TERMINAL_SUMMARY_SUCCESS",
  FILTER_TERMINAL_SUMMARY_FAILED: "FILTER_TERMINAL_SUMMARY_FAILED",
  GET_TOTAL_REGISTRATION_COUNT_SUMMARY_START: "GET_TOTAL_COUNT_SUMMARY_START",
  GET_TOTAL_REGISTRATION_COUNT_SUMMARY_SUCCESS: "GET_TOTAL_REGISTRATION_COUNT_SUMMARY_SUCCESS",
  GET_TOTAL_REGISTRATION_COUNT_SUMMARY_FAILED: "GET_TOTAL_REGISTRATION_COUNT_SUMMARY_FAILED",
  FILTER_TERMINAL_SUMMARY_COUNT_START: "FILTER_TERMINAL_SUMMARY_COUNT_START",
  FILTER_TERMINAL_SUMMARY_COUNT_SUCCESS: "FILTER_TERMINAL_SUMMARY_COUNT_SUCCESS",
  FILTER_TERMINAL_SUMMARY_COUNT_FAILED: "FILTER_TERMINAL_SUMMARY_COUNT_FAILED"
};

export default dashboardConstants;
